import { render, staticRenderFns } from "./ProjectEvaluationHeader.vue?vue&type=template&id=2f1036e7&scoped=true"
import script from "./project-evaluation-header.ts?vue&type=script&lang=ts&external"
export * from "./project-evaluation-header.ts?vue&type=script&lang=ts&external"
import style0 from "./project-evaluation-header.scss?vue&type=style&index=0&id=2f1036e7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1036e7",
  null
  
)

export default component.exports